























































































import { fetchRecordings, fetchRecordingsStatuses } from '@/core/api/recordings'
import { REQUEST_ERROR } from '@/core/events'
import _ from 'lodash'
import Vue from 'vue'

export default Vue.extend({
  components: {},
  data: () => ({
    loading: false,
    filter: {
      query: '',
      status: null,
    },
    statuses: [],
    items: [],
    itemsCount: null,
    page: 1,
    pageCount: 1,
    headers: [
      {
        text: 'Дата записи',
        value: 'starts_at',
      },
      {
        text: 'Источник',
        value: 'source.name',
      },
      {
        text: 'Программа',
        value: 'program.name',
      },
      {
        text: 'Поток',
        value: 'stream.name',
      },
      {
        text: 'Длительность',
        value: 'duration',
      },
      {
        text: 'Статус',
        value: 'status_name',
      },
      {
        text: 'Записи',
        value: 'files',
      },
      {
        text: 'Текст',
        value: 'text',
      },
    ],
  }),
  computed: {},
  async mounted() {
    this.statuses = await fetchRecordingsStatuses()
    this.fetch()
  },
  methods: {
    fetch() {
      this.loading = true
      fetchRecordings(this.page, this.filter)
        .then(({ results, count, pages }) => {
          this.items = results
          this.itemsCount = count
          this.pageCount = pages
        })
        .catch(() => {
          this.$event.$emit(REQUEST_ERROR)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onPageChange() {
      this.fetch()
    },
    onTextClick(item) {
      this.$modal.fire({ html: `<span style="white-space: pre-wrap;">${item.text}</span>` })
    },
    onFileClick(file) {
      const createdAt = this.$moment(file.capture_at).unix()
      window.open(
        `https://player.alviss.maismi.ru/play/?url=${file.url}&created_at=${createdAt}`,
        '_blank',
      )
    },
    onFilterChange: _.debounce(function(this: any, value: any) {
      this.page = 1
      this.fetch()
    }, 250),
  },
})
